import { Component, EventEmitter, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { PaymentType } from "src/app/enums/payment-type";
import { IPaymentLink } from "src/app/models/client/payment-link";
import { ClientService } from "src/app/services/client.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-buy-client-number-modal",
  templateUrl: "./buy-client-number-modal.component.html",
  styleUrls: ["./buy-client-number-modal.component.scss"],
})
export class BuyClientNumberModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<IPaymentLink | null>();

  selectedNumber = "";
  isPurchasing = false;
  errorMessage = "";

  constructor(
    private readonly _modalService: ModalService,
    private readonly _clientService: ClientService
  ) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.BuyClientNumber;
  }

  get isSubmitDisabled() {
    return this.isPurchasing || this.selectedNumber.length < 12;
  }

  onClose() {
    if (this.isPurchasing) {
      return;
    }
    this.errorMessage = "";
    this._modalService.closeModal();
    this.close.emit();
  }

  selectNumber(number: string) {
    if (this.isPurchasing) {
      return;
    }
    this.errorMessage = "";
    this.selectedNumber = number;
  }

  onSubmit() {
    if (this.isSubmitDisabled) {
      return;
    }

    this.isPurchasing = true;
    this.errorMessage = "";
    this._clientService.purchaseFaxNumber({
      type: PaymentType.FaxNumber,
      number: this.selectedNumber,
    }).subscribe({
      next: paymentLink => {
        this.isPurchasing = false;
        this._modalService.closeModal();
        this.submit.emit(paymentLink);
      },
      error: error => {
        this.isPurchasing = false;
        this.errorMessage = error?.error?.code === "ClientErrors.UnavailableNumber"
          ? "Phone number is unavailable please choose another number"
          : "Unable to purchase the number. Please try again.";
      },
    });
  }
}
